// Forgot password screen translations for all 11 supported languages

export const forgotPasswordTranslations = {
  pt: {
    title: "Recuperar palavra-passe",
    description: "Introduza o seu email e enviaremos um link para redefinir a palavra-passe",
    email: "Email",
    email_placeholder: "nome@empresa.com",
    email_help: "Introduza o email associado à sua conta MoneyLights",
    send_reset_link: "Enviar link de recuperação",
    sending: "A enviar...",
    back_to_login: "Voltar ao início de sessão",
    error_email_required: "Por favor introduza o seu email",
    error_invalid_email: "Por favor introduza um email válido",
    success_title: "Verifique o seu email",
    success_description: "Siga as instruções que enviámos para continuar",
    success_message: "Se existir uma conta com este email, receberá um link de recuperação dentro de alguns minutos.",
    success_instruction_1: "Clique no link de recuperação enviado para o seu email para criar uma nova palavra-passe.",
    success_instruction_2: "O link é válido por 24 horas. Se não receber o email, verifique a pasta de spam.",
    success_no_email: "Não recebeu o email?",
    success_try_again: "Tentar novamente",
    resending: "A enviar...",
    resend_confirmation: "Nova solicitação enviada com sucesso",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Precisa de ajuda?"
  },
  en: {
    title: "Reset your password",
    description: "Enter your email and we'll send you a link to reset your password",
    email: "Email",
    email_placeholder: "name@company.com",
    email_help: "Enter the email associated with your MoneyLights account",
    send_reset_link: "Send reset link",
    sending: "Sending...",
    back_to_login: "Back to sign in",
    error_email_required: "Please enter your email",
    error_invalid_email: "Please enter a valid email",
    success_title: "Check your email",
    success_description: "Follow the instructions we've sent to continue",
    success_message: "If an account exists with this email, you will receive a reset link within a few minutes.",
    success_instruction_1: "Click on the reset link sent to your email to create a new password.",
    success_instruction_2: "The link is valid for 24 hours. If you don't receive the email, check your spam folder.",
    success_no_email: "Didn't receive the email?",
    success_try_again: "Try again",
    resending: "Sending...",
    resend_confirmation: "New request sent successfully",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Need help?"
  },
  es: {
    title: "Recuperar contraseña",
    description: "Introduce tu email y te enviaremos un enlace para restablecer tu contraseña",
    email: "Correo electrónico",
    email_placeholder: "nombre@empresa.com",
    email_help: "Introduce el email asociado a tu cuenta de MoneyLights",
    send_reset_link: "Enviar enlace de recuperación",
    sending: "Enviando...",
    back_to_login: "Volver al inicio de sesión",
    error_email_required: "Por favor introduce tu email",
    error_invalid_email: "Por favor introduce un email válido",
    success_title: "Revisa tu correo electrónico",
    success_description: "Sigue las instrucciones que hemos enviado para continuar",
    success_message: "Si existe una cuenta con este email, recibirás un enlace de recuperación en unos minutos.",
    success_instruction_1: "Haz clic en el enlace de recuperación enviado a tu correo para crear una nueva contraseña.",
    success_instruction_2: "El enlace es válido durante 24 horas. Si no recibes el correo, revisa tu carpeta de spam.",
    success_no_email: "¿No recibiste el correo?",
    success_try_again: "Intentar de nuevo",
    resending: "Enviando...",
    resend_confirmation: "Nueva solicitud enviada con éxito",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "¿Necesitas ayuda?"
  },
  fr: {
    title: "Réinitialiser votre mot de passe",
    description: "Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe",
    email: "Email",
    email_placeholder: "nom@entreprise.com",
    email_help: "Entrez l'email associé à votre compte MoneyLights",
    send_reset_link: "Envoyer le lien de réinitialisation",
    sending: "Envoi en cours...",
    back_to_login: "Retour à la connexion",
    error_email_required: "Veuillez entrer votre email",
    error_invalid_email: "Veuillez entrer un email valide",
    success_title: "Vérifiez votre email",
    success_description: "Suivez les instructions que nous avons envoyées pour continuer",
    success_message: "Si un compte existe avec cet email, vous recevrez un lien de réinitialisation dans quelques minutes.",
    success_instruction_1: "Cliquez sur le lien de réinitialisation envoyé à votre email pour créer un nouveau mot de passe.",
    success_instruction_2: "Le lien est valide pendant 24 heures. Si vous ne recevez pas l'email, vérifiez votre dossier spam.",
    success_no_email: "Vous n'avez pas reçu l'email?",
    success_try_again: "Réessayer",
    resending: "Envoi en cours...",
    resend_confirmation: "Nouvelle demande envoyée avec succès",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Besoin d'aide?"
  },
  de: {
    title: "Passwort zurücksetzen",
    description: "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts",
    email: "E-Mail",
    email_placeholder: "name@unternehmen.com",
    email_help: "Geben Sie die E-Mail ein, die mit Ihrem MoneyLights-Konto verknüpft ist",
    send_reset_link: "Zurücksetzungslink senden",
    sending: "Wird gesendet...",
    back_to_login: "Zurück zur Anmeldung",
    error_email_required: "Bitte geben Sie Ihre E-Mail ein",
    error_invalid_email: "Bitte geben Sie eine gültige E-Mail ein",
    success_title: "Überprüfen Sie Ihre E-Mail",
    success_description: "Folgen Sie den gesendeten Anweisungen, um fortzufahren",
    success_message: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie innerhalb weniger Minuten einen Zurücksetzungslink.",
    success_instruction_1: "Klicken Sie auf den Zurücksetzungslink, der an Ihre E-Mail gesendet wurde, um ein neues Passwort zu erstellen.",
    success_instruction_2: "Der Link ist 24 Stunden gültig. Wenn Sie die E-Mail nicht erhalten, überprüfen Sie Ihren Spam-Ordner.",
    success_no_email: "E-Mail nicht erhalten?",
    success_try_again: "Erneut versuchen",
    resending: "Wird gesendet...",
    resend_confirmation: "Neue Anfrage erfolgreich gesendet",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Brauchen Sie Hilfe?"
  },
  it: {
    title: "Reimposta la password",
    description: "Inserisci la tua email e ti invieremo un link per reimpostare la password",
    email: "Email",
    email_placeholder: "nome@azienda.com",
    email_help: "Inserisci l'email associata al tuo account MoneyLights",
    send_reset_link: "Invia link di reimpostazione",
    sending: "Invio in corso...",
    back_to_login: "Torna al login",
    error_email_required: "Per favore inserisci la tua email",
    error_invalid_email: "Per favore inserisci un'email valida",
    success_title: "Controlla la tua email",
    success_description: "Segui le istruzioni che abbiamo inviato per continuare",
    success_message: "Se esiste un account con questa email, riceverai un link di reimpostazione entro pochi minuti.",
    success_instruction_1: "Clicca sul link di reimpostazione inviato alla tua email per creare una nuova password.",
    success_instruction_2: "Il link è valido per 24 ore. Se non ricevi l'email, controlla la cartella spam.",
    success_no_email: "Non hai ricevuto l'email?",
    success_try_again: "Riprova",
    resending: "Invio in corso...",
    resend_confirmation: "Nuova richiesta inviata con successo",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Hai bisogno di aiuto?"
  },
  nl: {
    title: "Wachtwoord opnieuw instellen",
    description: "Voer uw e-mail in en we sturen u een link om uw wachtwoord opnieuw in te stellen",
    email: "E-mail",
    email_placeholder: "naam@bedrijf.com",
    email_help: "Voer het e-mailadres in dat is gekoppeld aan uw MoneyLights-account",
    send_reset_link: "Herstellink versturen",
    sending: "Verzenden...",
    back_to_login: "Terug naar inloggen",
    error_email_required: "Voer uw e-mailadres in",
    error_invalid_email: "Voer een geldig e-mailadres in",
    success_title: "Controleer uw e-mail",
    success_description: "Volg de instructies die we hebben verzonden om door te gaan",
    success_message: "Als er een account bestaat met deze e-mail, ontvangt u binnen enkele minuten een herstellink.",
    success_instruction_1: "Klik op de herstellink die naar uw e-mail is verzonden om een nieuw wachtwoord aan te maken.",
    success_instruction_2: "De link is 24 uur geldig. Als u de e-mail niet ontvangt, controleer dan uw spam-map.",
    success_no_email: "E-mail niet ontvangen?",
    success_try_again: "Opnieuw proberen",
    resending: "Verzenden...",
    resend_confirmation: "Nieuwe aanvraag succesvol verzonden",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Hulp nodig?"
  },
  da: {
    title: "Nulstil din adgangskode",
    description: "Indtast din e-mail, og vi sender dig et link til at nulstille din adgangskode",
    email: "E-mail",
    email_placeholder: "navn@virksomhed.com",
    email_help: "Indtast den e-mail, der er tilknyttet din MoneyLights-konto",
    send_reset_link: "Send nulstillingslink",
    sending: "Sender...",
    back_to_login: "Tilbage til login",
    error_email_required: "Indtast venligst din e-mail",
    error_invalid_email: "Indtast venligst en gyldig e-mail",
    success_title: "Tjek din e-mail",
    success_description: "Følg instruktionerne, vi har sendt for at fortsætte",
    success_message: "Hvis der findes en konto med denne e-mail, vil du modtage et nulstillingslink inden for få minutter.",
    success_instruction_1: "Klik på nulstillingslinket sendt til din e-mail for at oprette en ny adgangskode.",
    success_instruction_2: "Linket er gyldigt i 24 timer. Hvis du ikke modtager e-mailen, skal du tjekke din spam-mappe.",
    success_no_email: "Modtog du ikke e-mailen?",
    success_try_again: "Prøv igen",
    resending: "Sender...",
    resend_confirmation: "Ny anmodning sendt med succes",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Brug for hjælp?"
  },
  sv: {
    title: "Återställ ditt lösenord",
    description: "Ange din e-post så skickar vi dig en länk för att återställa ditt lösenord",
    email: "E-post",
    email_placeholder: "namn@företag.com",
    email_help: "Ange e-posten som är kopplad till ditt MoneyLights-konto",
    send_reset_link: "Skicka återställningslänk",
    sending: "Skickar...",
    back_to_login: "Tillbaka till inloggning",
    error_email_required: "Vänligen ange din e-post",
    error_invalid_email: "Vänligen ange en giltig e-post",
    success_title: "Kontrollera din e-post",
    success_description: "Följ instruktionerna vi har skickat för att fortsätta",
    success_message: "Om ett konto finns med denna e-post kommer du att få en återställningslänk inom några minuter.",
    success_instruction_1: "Klicka på återställningslänken som skickats till din e-post för att skapa ett nytt lösenord.",
    success_instruction_2: "Länken är giltig i 24 timmar. Om du inte får e-postmeddelandet, kontrollera din skräppostmapp.",
    success_no_email: "Fick du inte e-postmeddelandet?",
    success_try_again: "Försök igen",
    resending: "Skickar...",
    resend_confirmation: "Ny begäran skickad",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Behöver du hjälp?"
  },
  fi: {
    title: "Palauta salasanasi",
    description: "Anna sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan palauttamiseksi",
    email: "Sähköposti",
    email_placeholder: "nimi@yritys.com",
    email_help: "Syötä MoneyLights-tiliisi liittyvä sähköpostiosoite",
    send_reset_link: "Lähetä palautuslinkki",
    sending: "Lähetetään...",
    back_to_login: "Takaisin kirjautumiseen",
    error_email_required: "Syötä sähköpostiosoitteesi",
    error_invalid_email: "Syötä kelvollinen sähköpostiosoite",
    success_title: "Tarkista sähköpostisi",
    success_description: "Seuraa lähettämiämme ohjeita jatkaaksesi",
    success_message: "Jos tilillä on tämä sähköposti, saat palautuslinkin muutaman minuutin sisällä.",
    success_instruction_1: "Klikkaa sähköpostiisi lähetettyä palautuslinkkiä luodaksesi uuden salasanan.",
    success_instruction_2: "Linkki on voimassa 24 tuntia. Jos et saa sähköpostia, tarkista roskapostikansio.",
    success_no_email: "Et saanut sähköpostia?",
    success_try_again: "Yritä uudelleen",
    resending: "Lähetetään...",
    resend_confirmation: "Uusi pyyntö lähetetty onnistuneesti",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Tarvitsetko apua?"
  },
  et: {
    title: "Lähtesta parool",
    description: "Sisesta oma e-post ja saadame sulle lingi parooli lähtestamiseks",
    email: "E-post",
    email_placeholder: "nimi@ettevote.com",
    email_help: "Sisesta e-post, mis on seotud sinu MoneyLights kontoga",
    send_reset_link: "Saada lähtestamislink",
    sending: "Saatmine...",
    back_to_login: "Tagasi sisselogimisse",
    error_email_required: "Palun sisesta oma e-post",
    error_invalid_email: "Palun sisesta kehtiv e-post",
    success_title: "Kontrolli oma e-posti",
    success_description: "Järgi meie saadetud juhiseid, et jätkata",
    success_message: "Kui selle e-postiga konto eksisteerib, saad lähtestamislingi mõne minuti jooksul.",
    success_instruction_1: "Klõpsa e-posti teel saadetud lähtestamislingil, et luua uus parool.",
    success_instruction_2: "Link kehtib 24 tundi. Kui sa ei saa e-posti, kontrolli rämpsposti kausta.",
    success_no_email: "Kas sa ei saanud e-kirja?",
    success_try_again: "Proovi uuesti",
    resending: "Saatmine...",
    resend_confirmation: "Uus taotlus edukalt saadetud",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Vajad abi?"
  }
};
